import { Card, CardContent, Container, Grid, Stack, Typography } from '@mui/material';

// Pestaña "Acerca de nosotros" de la tienda. Contenido provisional (lorem ipsum) hasta
// tener los textos definitivos de la empresa.
const SECTIONS = [
  {
    title: 'Misión',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    title: 'Visión',
    text: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  },
  {
    title: 'Valores',
    text: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
  },
];

export default function AboutPage() {
  return (
    <Container maxWidth="lg" sx={{ py: 5 }}>
      <Stack spacing={2} sx={{ mb: 5, maxWidth: 800 }}>
        <Typography variant="h4">Acerca de nosotros</Typography>
        <Typography color="text.secondary">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante
          dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris.
        </Typography>
        <Typography color="text.secondary">
          Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti
          sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur sodales ligula in libero.
        </Typography>
      </Stack>

      <Grid container spacing={3}>
        {SECTIONS.map((section) => (
          <Grid key={section.title} size={{ xs: 12, md: 4 }}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 1 }}>
                  {section.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {section.text}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
